/**
 * Runtime API URL detection
 * Automatically detects backend URL based on deployment environment.
 * Uses window.location.hostname + port to detect environment (localhost vs production).
 * Does NOT read REACT_APP_API_URL env var — hostname detection is the source of truth.
 */

export const getApiBaseUrl = () => {
  const frontendHost = window.location.hostname;
  const frontendPort = window.location.port;

  // LOCAL STAGING: localhost:12001 → localhost:12000
  if (frontendHost === 'localhost' && (frontendPort === '12001' || frontendPort === '3000')) {
    return 'http://localhost:12000';
  }

  // LOCAL PROD: localhost:5070 → localhost:8042 (for local testing only)
  if (frontendHost === 'localhost' && frontendPort === '5070') {
    return 'http://localhost:8042';
  }

  // PRODUCTION: use same origin (Caddy/nginx proxies /api/ to backend)
  // window.location.origin includes port if non-standard, e.g. http://192.168.0.26:5070
  if (frontendHost !== 'localhost' && frontendHost !== '127.0.0.1') {
    return window.location.origin;
  }

  // Fallback to local staging
  return 'http://localhost:12000';
};

export const API_BASE_URL = getApiBaseUrl();
